export let aboutUsEN = {
  h1: "About PilotD Technology",
  h2: "Originated in Germany and founded in 2017.",
  h3: "PilotD Technology develops the cutting-edge  \"AI + Full-Physics World Model\" to deliver massive, high-precision synthetic data,  verification and validation solutions for intelligent agents.",
  moudle1: {
    h1: "Values",
    h2: "Fine, Define, Refine",
  },
  moudle2: {
    h1: "Mission",
    h2: "Aiming to solve the bottleneck of intelligent agent commercialization, and starting from full-physical environmental perception sensor model, we are devoted to the transformation of industry empowered by simulation based development and test methods.",
  },
  moudle3: {
    h1: "Vision",
    h2: "Enjoy an efficient life empowered by AI technology",
  },
  development: {
    h1: "Development History",
    list: [
      {
        year: "2025",
        events: [
          {
            date: 'December',
            introduce: 'Awarded “2025 Metaverse Exemplary Case” by the Ministry of Industry and Information Technology.',
          },
          {
            date: 'November',
            introduce: 'Included as a “Gazelle Star” on Ningbo’s 2025 High-Growth Enterprise List.',
          },
          {
            date: 'September',
            introduce: 'KPMG Leading Auto Tech 50 Pioneer (4th Consecutive Year).',
          }
        ]
      },
      {
        year: "2024",
        events: [
          {
            date: 'November',
            introduce: 'Member of the China Society of Automotive Engineers & Third Prize for Scientific and Technological Progress.',
          },
          {
            date: 'June',
            introduce: 'Named a “Rising Star” on the 2024 China Automotive Supply Chain Global Expansion Enterprises List.',
          },
        ]
      },
      {
        year: "2023",
        events: [
          {
            date: 'December',
            introduce: 'Appointed as a Governing Unit of the Ningbo Metaverse Society.',
          },
          {
            date: 'August',
            introduce: 'Dr. -Ing. Peng Cao elected to the ASAM ACADS Expert Committee on Autonomous Driving Simulation Technology.',
          },
        ]
      },
      {
        year: "2022",
        events: [
          {
            date: 'Jaunary',
            introduce: "PilotD Automotive successfully completed a Pre-A round financing of tens of millions, led by Hillhouse Capital. New Future Capital, Tielin Capital, Ningbo Angel Investment Guiding Fund, and Ningbo Zhenhai Huizhi Angel Fund also participated in the investment."
          }
        ]
      },
      {
        year: "2021",
        events: [
          {
            date: 'December',
            introduce: "The global R&D headquarters of PilotD Automotive was established in Zhenhai District, Ningbo."
          }
        ]
      },
      {
        year: '2019',
        events: [
          {
            date: 'September',
            introduce: "PilotD Automotive R&D Center was established in Yangpu District, Shanghai."
          },
        ]
      },
      {
        year: '2018',
        events: [
          {
            date: 'December',
            introduce: "PilotD Automotive Driver-Simulator Factory was established in Songjiang District, Shanghai."
          },
        ]
      },
      {
        year: '2017',
        events: [
          {
            date: 'March',
            introduce: "HyperMatrix (Tangshan) Automotive Service Co., Ltd. was established, responsible for AI Team and Hil Device.",
          },
          {
            date: 'February',
            introduce: "PilotD Automotive (Shanghai) Co., Ltd. was officially registered and established.",
          },
        ]
      }
    ],
  },
};
export let aboutUsCN = {
  h1: "关于沛岱科技",
  h2: "沛岱科技，源自德国，成立于2017年。",
  h3: "凭借全球领先的“AI+全物理模型World Model”核心建模技术，我们专注于为AI空间智能体提供海量、高精度的合成数据&训练及测试解决方案。",
  moudle1: {
    h1: "我们的价值观",
    h2: "技精于心，领航未来",
  },
  moudle2: {
    h1: "我们的使命",
    h2: "以解决AI智能体落地的“卡脖子”问题为目标，以全物理级环境感知传感器模型为起点，助力AI智能体仿真测试与开发，为行业实现全新变革",
  },
  moudle3: {
    h1: "我们的愿景",
    h2: "赋能AI，享高效人生",
  },
  development: {
    h1: "发展历程",
    list: [
      {
        year: "2025",
        events: [
          {
            date: '12月',
            introduce: '入选工信部“2025年元宇宙典型案例”',
          },
          {
            date: '11月',
            introduce: '入选2025年宁波市“瞪羚之星”企业榜单',
          },
          {
            date: '9月',
            introduce: '连续第四年蝉联毕马威领先汽车科技企业50·先锋企业',
          }
        ]
      },
      {
        year: "2024",
        events: [
          {
            date: '11月',
            introduce: '中国汽车工程学会会员 科技进步奖三等奖',
          },
          {
            date: '6月',
            introduce: '2024中国汽车供应链出海企业榜·新锐企业',
          },
        ]
      },
      {
        year: "2023",
        events: [
          {
            date: '12月',
            introduce: '宁波市元宇宙学会理事单位',
          },
          {
            date: '8月',
            introduce: '曹鹏博士当选ASAM ACADS自动驾驶仿真技术专家委员会委员',
          },
        ]
      },
      {
        year: "2022",
        events: [
          {
            date: '1月',
            introduce: "沛岱汽车顺利完成PreA轮数千万融资，由高瓴创投领投，丰新资本、铁林资本、宁波市天使投资引导基金、宁波市镇海汇智天使基金跟投"
          }
        ]
      },
      {
        year: "2021",
        events: [
          {
            date: '12月',
            introduce: "沛岱汽车全球研发总部成立，位于宁波市镇海区"
          }
        ]
      },
      {
        year: '2019',
        events: [
          {
            date: '9月',
            introduce: "沛岱汽车研发中心成立，位于上海市杨浦区",
          },
        ]
      },
      {
        year: '2018',
        events: [
          {
            date: '12月',
            introduce: "沛岱汽车驾驶员仿真器产能部署落地，位于上海市松江区",
          },
        ]
      },
      {
        year: '2017',
        events: [
          {
            date: '3月',
            introduce: "河北唐山子公司成立，负责AI Team以及Hil Device",
          },
          {
            date: '2月',
            introduce: "沛岱（上海）汽车有限公司正式注册成立",
          },
        ]
      }
    ],
  },
};
